module.exports = __webpack_public_path__ + "media/images/getting-started/tiktok-profile-399d39c91f40ce14659b66104e02031f.png";